import { render } from "./stack5DimFollowResult.vue?vue&type=template&id=54d5a94f&scoped=true"
import script from "./stack5DimFollowResult.vue?vue&type=script&lang=js"
export * from "./stack5DimFollowResult.vue?vue&type=script&lang=js"

import "./stack5DimFollowResult.vue?vue&type=style&index=0&id=54d5a94f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d5a94f"]])

export default __exports__